module.exports = __webpack_public_path__ + "static/media/Raleway-ExtraLight.3d22c4cb.ttf";